import React,{useState,useEffect} from 'react'



import { Switch } from '@mui/material';
import emergencyContactServices from '../emergencyContactServices';
import EmergencyContactForm from '../components/EmergencyContactForm';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import AppLayout from '../../../../layout/components/AppLayout';


function ManageEmergencyContactPage() {
  const [directoryList,setDirectoryList] = useState(null);
  const [masters,getMasterLabel] = useSystemMasterList(['emergency-contact-type']);
  const getDirectoryList = () =>{
    emergencyContactServices.getList().then(res=>{
      setDirectoryList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }
  useEffect(()=>{
    getDirectoryList()
  },[])

  const handleStatusChange = (e,id) =>{
    let payload = {
      id:id,
      status:e.target.checked ? 1 : 0,
    }
    console.log(payload);
    emergencyContactServices.save(payload).then(res=>{
      getDirectoryList();
    })
  }

  return (
    <AppLayout>
      <div className="container">
      <div className='row'>
        <div className='col-md-9'>
          <h3>Directory List</h3>
        </div>
        <div className='col-md-3'>
        {masters &&<span className='float-end'><EmergencyContactForm refreshList={getDirectoryList} masters={masters} /></span> }
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <table className='table'>
            <thead>
              <tr>
                <td>Contact Type</td>
                <td>Contact For</td>
                <td>Phone</td>
              </tr>
            </thead>
            <tbody>
              {directoryList && directoryList.map(directory=>
                <tr key={directory.id}>
                  <td>{ getMasterLabel("emergency-contact-type", directory.contactType)}</td>
                  <td>{directory.title}</td>
                  <td>{directory.phone}</td>
                  <td>
                    <div>
                      {masters && <EmergencyContactForm refreshList={getDirectoryList} data={directory} masters={masters} /> }
                      <Switch 
                        color="success"
                        checked={directory.status === 1}
                        onChange={(e)=>handleStatusChange(e,directory.id)}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      </div>
    </AppLayout>
  )
}

export default ManageEmergencyContactPage